import axios from 'axios';

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_DOMAIN,
    withCredentials: true,
});

/** Человекочитаемое сообщение из ответа API (или generic-фолбэк). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const apiErrorMessage = (error: any): string =>
    error?.response?.data?.message || 'Something went wrong. Please try again.';
